import React, { useCallback } from 'react';
import { useSelectHotel } from '@honeycomb/data';
import { hotelSelectedRouting, router } from '@honeycomb/routing';
import { Anchor } from '@honeycomb/ui-core';
import { getQueryString } from '../../../utils/getQueryString';
import { HotelMapPopover } from './HotelMapPopover';
export function HotelMapPopoverLink({ staticDetails, pricingSummary }) {
    const { estabId } = staticDetails;
    const [selectHotel] = useSelectHotel([(params) => router.push(params, hotelSelectedRouting)]);
    const detailsPageHref = () => {
        return `/hotels/${estabId}${getQueryString(router === null || router === void 0 ? void 0 : router.query())}`;
    };
    const handleSelectHotel = useCallback((event) => {
        event.preventDefault();
        selectHotel({ hotelId: estabId });
    }, [estabId, selectHotel]);
    return (React.createElement(Anchor, { href: detailsPageHref(), onClick: handleSelectHotel, underline: "none" },
        React.createElement(HotelMapPopover, { staticDetails: staticDetails, pricingSummary: pricingSummary })));
}
